<template>
    <div>
        <bar-chart :xdata='xdata' :series='series' :unit="'￥'" :type="'age'"/>
        <p class="charttips">说明：图示为所选统计区间各年龄组赔付金额</p>
    </div>
</template>
<script>
// 柱状图
import BarChart from '@/components/layouts/BarChart'
export default {
    computed:{
        xdata(){
            let arr=[ ]
            this.ageArr.map(item=>{
                 arr.push(item.groupName)
             })
            return arr
        },
        series(){
            let data=[]
                    //   {
        //   name: 'pageA',
        //   type: 'bar',
        //   stack: 'vistors',
        //   barWidth: '60%',
        //   data: [79, 52, 200, 334, 390, 330, 220],
        //   animationDuration
        // },
             this.ageArr.map(item=>{
                //  data.push(item.totalAmount)
                 data.push({
                    name:item.groupName,
                     value:item.totalAmount,
                     datas:[item.insuredNum,item.totalAmount]
                 })
             })
             return [{
                type: 'bar',
                stack: 'vistors',
                barWidth: '60%',
                data: data,
                 barMaxWidth:30,
                animationDuration:2000
             }]
        }
    },
    props:{
        ageArr:{
            type:Array,
            default:()=>[]
        }
    },
    components:{
        BarChart
    }
}
</script>